/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when no parameter was supplied
 * @export
 * @class ParameterRequiredError
 * @extends {Error}
 */
export class ParameterRequiredError extends Error {
  /**
   * Creates an instance of ParameterRequiredError
   * @param {string} message The Error `message`
   * @memberof ParameterRequiredError
   */
  constructor(message) {
    super(message);
    this.name = `ParameterRequiredError`;
  }
}

/**
 * Called when no parameter was supplied
 * @param {sting} parameter The name of the required `parameter`
 * @returns {never} never
 */
const throwParameterRequiredError = (parameter) => {
  throw new ParameterRequiredError(
    stripIndent(`
    Expected "${parameter}" to be defined.
    Got: "undefined".
    `),
  );
};

export default throwParameterRequiredError;
